import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';

const namespace = 'CHECK_CANCELATION_ACTION';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
